module.exports = __webpack_public_path__ + "static/media/hotel_demo_picture.dfffa51c.png";